import onDomReady from '../../utils/dom/onDomReady';
import UnsavedChangesGuard from '../../features/unsavedChanges/UnsavedChangesGuard';

onDomReady(() => {
  new UnsavedChangesGuard().init();
});
